import { render, staticRenderFns } from "./reason-for-attention.vue?vue&type=template&id=609c749a&scoped=true"
import script from "./reason-for-attention.vue?vue&type=script&lang=js"
export * from "./reason-for-attention.vue?vue&type=script&lang=js"
import style0 from "./reason-for-attention.vue?vue&type=style&index=0&id=609c749a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609c749a",
  null
  
)

export default component.exports